// extracted by mini-css-extract-plugin
module.exports = {"title":"LocationsForm_title__22pft","inputGroupWrapper":"LocationsForm_inputGroupWrapper__2BPpP"};